import React from "react";
import styled from "@emotion/styled";
import Background from '../assets/header-background.png';
import End from "../sections/7-end";
import CommuintyDetails from "./commuintytraders";
import BasicTabs from "../components/communitytabs";
import Card5 from '../assets/card5.png';
import Popup5 from '../assets/popup5.png';

const BackgroundDiv = styled.div`
    background-image: url(${Background});
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
`
const CardDetail5 = () => {
    
    const ongoingCard1 = {
        symbol: 'BTUSDT',
        buy: 'Buy',
        buysell: '20.0X',
        pnl: 'PnL%(Closed)',
        leverage: '0.99%',
        avgCost: '27,007.7 USDT',
        closePrice: '27,089.9 USDT',
        imageSrc: Popup5,
        name: '@crazylandinhabitant',
    }
    const ongoingCard2 = {
        symbol: 'ETHUSDT',
        buy: 'Buy',
        buysell: '20.0X',
        pnl: 'PnL%(Closed)',
        leverage: '4.99%',
        avgCost: '1,647.2 USDT',
        closePrice: '1,620 USDT',
        imageSrc: Popup5,
        name: '@crazylandinhabitant',
    }
    return(
        <div style={{backgroundColor: 'black'}}>
            <BackgroundDiv>
                    <CommuintyDetails
                        id='@crazylandinhabitant'
                        traderimg = {Card5}
                        investment = '$1,500'
                        roi = '+271.5%'
                        winrate = '75%'
                        totaltrades = '8'
                        returnamount = '$3,710'
                        position = 'Open'
                    />
            </BackgroundDiv>
            <BasicTabs
            symbol= 'BTUSDT'
            buy = 'Buy'
            buysell = '20.0X'
            pnl = 'PnL%(Closed)'
            leverage = '7.25%'
            avgCost = '27,007.7 USDT'
            closePrice = '27,089.9 USDT'
            imageSrc = {Popup5}
            name = '@crazylandinhabitant'
            ongoingCard1 = {ongoingCard1}
            ongoingCard2={ongoingCard2}
            />
            <End/>
        </div>
    )
}
export default CardDetail5;